$(function() {

	$('#program-tutorial').each(function() {
		var $form = $(this);
		$form.find('.radio').each(function() {
			var $container = $(this);

			$container.find('input').on('change', function() {
				var correct = $(this).val() == $container.attr('data-correct-id');
				$container.find('.alert-danger')[correct ? 'addClass' : 'removeClass']('hidden');
				$container.find('.alert-success')[!correct ? 'addClass' : 'removeClass']('hidden');
			});
		})
	});

});